import { createGlobalStyle } from 'styled-components'
import 'normalize.css/normalize.css'
import 'rc-slider/assets/index.css';
import { withTypographyDefault } from '@components/Typography'
import '@styles/fonts.css'

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }
  
	html, body {
    ${withTypographyDefault};
		margin: 0;
		padding: 0;
    height: 100%;
    color: ${(props) => props.theme.colors.graphite};
	}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  a {
    color: ${(props) => props.theme.colors.green};
    text-decoration: none;
    cursor: pointer;
  }
`

export default GlobalStyle
